/**
 * Die beiden Fassungen des Standardlogos — hell `/logo.png` (blauer Schriftzug),
 * dunkel `/logo-dunkel.png` (weisser Schriftzug, Wirbel unverändert). CSS zeigt
 * je nach `<html data-theme>` eine davon (index.css, `.logo-bild--hell/--dunkel`).
 * Ohne Hooks, damit auch serverseitige Fehlerseiten sie nutzen können.
 *
 * Beide nachrangig (`fetchPriority`): Die einzige Seite mit diesem Logo ist die
 * Fehler- und 404-Seite, und Next.js rendert die `not-found.tsx` beider
 * Root-Layouts in die Server-Antwort JEDER Seite mit (als Grenze, falls
 * `notFound()` fällt). Jedes `<img>` darin wird dort zu einem Vorlade-Hinweis
 * — bis 25.10.2026 lud deshalb jede Seite `/logo.png` und `/logo-dunkel.png`,
 * ohne sie je zu zeigen. Auf der Fehlerseite selbst lädt das Logo trotzdem,
 * nur ohne Vorrang (nie `loading="lazy"`, siehe `Logo.tsx`).
 */
import type { CSSProperties, ReactEventHandler } from 'react';

export const LOGO_HELL = '/logo.png';
export const LOGO_DUNKEL = '/logo-dunkel.png';

export interface LogoProps {
  alt: string;
  className?: string;
  style?: CSSProperties;
  onError?: ReactEventHandler<HTMLImageElement>;
}

export default function StandardLogo({ alt, className = '', style, onError }: LogoProps) {
  return (
    <>
      <img className={`logo-bild logo-bild--hell ${className}`} src={LOGO_HELL} alt={alt} style={style} onError={onError} fetchPriority="low" />
      <img className={`logo-bild--dunkel ${className}`} src={LOGO_DUNKEL} alt={alt} style={style} onError={onError} fetchPriority="low" />
    </>
  );
}
